<div style="margin: 4px">
	<span class="glyphicon glyphicon-earphone"></span>
	<input [(ngModel)]="mData.value" (ngModelChange)="onPhoneChange($event)" style="border: none; border-radius: 4px; color: #000000" type="text">
	<span (click)="removeClicked.emit()" class="fa fa-close"></span>
</div>